<template>
  <div>
    <div style="width: 900px; margin: 0 auto">
      <div style="text-align: center; margin-bottom: 50px; padding-top: 100px">
        <span style="font-size: 25px">{{$t('login.login5')}}</span>
      </div>
      <el-steps :active="active" finish-status="success">
        <el-step :title="$t('address.address40')"></el-step>
        <el-step :title="$t('changeAccount.changeAccount10')"></el-step>
        <el-step :title="$t('login.login6')"></el-step>
        <el-step :title="$t('changeAccount.changeAccount12')"></el-step>
      </el-steps>
      <div class="block">
        <el-carousel
          style="margin-top: 100px"
          indicator-position="none"
          arrow="never"
          :autoplay="false"
          :loop="false"
          ref="carousel"
        >
          <el-carousel-item name="email">
            <div>
              <div>
                <el-input
                  :placeholder="$t('login.login7')"
                  v-model="emailAddress"
                  auto-complete="new-accounts"
                  style="width: 290px; margin-left: 300px; margin-top: 50px"
                  @blur="checkInput"
                  @focus="clearTip"
                >
                  <i slot="prefix" class="el-input__icon el-icon-message"></i>
                </el-input>
                <div
                  style="width: 308px; display: inline-block"
                  v-if="tipActive"
                >
                  <img
                    src="../assets/images/setting/error.png"
                    alt=""
                    style="float: left; margin-left: 20px"
                  />
                  <span style="color: red; font-size: 15px">{{ tip }}</span>
                </div>
              </div>
            </div>
            <div>
              <el-button
                @click="next"
                type="info"
                style="
                  width: 291px;
                  height: 50px;
                  margin-left: 300px !important;
                  margin-top: 25px;
                "
                >{{$t('changeAccount.changeAccount17')}}</el-button
              >
            </div>
          </el-carousel-item>
          <el-carousel-item name="check">
            <div>
              <div style="width: 300px; margin-left: 300px">
                <span style="font-size: 16px">
                  {{$t('login.login8')}}：{{ showEmail }}
                </span>
              </div>
              <div>
                <el-input
                  :placeholder="$t('changeAccount.changeAccount13')"
                  v-model="verifyCode"
                  type="text"
                  auto-complete="new-accounts"
                  style="width: 200px; margin-left: 300px; margin-top: 25px"
                  @blur="checkVerityCode"
                  @focus="clearTip"
                >
                  <i slot="prefix" class="el-input__icon el-icon-message"></i>
                </el-input>
                <el-button
                  style="width: 100px; height: 50px"
                  type="info"
                  @click="sendCode"
                  :disabled="disabled"
                  >{{ sendBtnText }}</el-button
                >
                <div
                  style="width: 270px; display: inline-block"
                  v-if="tipActive"
                >
                  <img
                    src="../assets/images/setting/error.png"
                    alt=""
                    style="float: left; margin-left: 20px"
                    v-if="!res"
                  />
                  <img
                    src="../assets/images/setting/p0.png"
                    alt=""
                    style="float: left; margin-left: 20px"
                    v-if="res"
                  />
                  <span style="color: red; font-size: 15px" v-if="!res">{{
                    tip
                  }}</span>
                  <span style="color: green; font-size: 15px" v-if="res">{{
                    tip
                  }}</span>
                </div>
              </div>
            </div>
            <el-button
              @click="next"
              type="info"
              style="
                width: 300px;
                height: 50px;
                margin-left: 300px !important;
                margin-top: 25px;
              "
              >{{$t('changeAccount.changeAccount17')}}</el-button
            >
          </el-carousel-item>
          <el-carousel-item name="set">
            <div>
              <div>
                <el-input
                  type="password"
                  :placeholder="$t('login.login9')"
                  v-model="password"
                  auto-complete="new-password"
                  style="width: 300px; margin-left: 300px"
                  @blur="checkPassword(0)"
                  @focus="clearTip"
                >
                  <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                </el-input>
                <div
                  style="width: 300px; display: inline-block"
                  v-if="tipActive"
                >
                  <img
                    src="../assets/images/setting/error.png"
                    alt=""
                    style="float: left; margin-left: 20px"
                  />
                  <span style="color: red; font-size: 15px">{{ tip }}</span>
                </div>
              </div>
              <div>
                <el-input
                  type="password"
                  :placeholder="$t('login.login10')"
                  v-model="rePassword"
                  auto-complete="new-password"
                  style="width: 300px; margin-left: 300px; margin-top: 25px"
                  @blur="checkPassword(1)"
                  @focus="clearTip"
                >
                  <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                </el-input>
              </div>
            </div>
            <el-button
              @click="next"
              type="info"
              style="
                width: 300px;
                height: 50px;
                margin-left: 300px !important;
                margin-top: 25px;
              "
              >{{$t('changeAccount.changeAccount17')}}</el-button
            >
          </el-carousel-item>
          <el-carousel-item name="complete">
            <div style="text-align: center">
              <img src="../assets/images/setting/u534.png" alt="" />
            </div>
            <div style="text-align: center; margin-top: 15px">
              <span style="font-size: 20px">{{$t('loginR.login28')}}</span>
            </div>
            <div style="text-align: center; margin-top: 10px">
              <span style="font-size: 16px"
                >{{$t('loginR.login29')}}{{ timeCount }}{{$t('loginR.login35')}}</span
              >
            </div>
            <el-button
              @click="next"
              type="info"
              style="
                width: 300px;
                height: 50px;
                margin-left: 300px !important;
                margin-top: 25px;
              "
              >{{$t('loginR.login30')}}</el-button
            >
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
<style>
.el-input__inner {
  height: 50px;
  font-size: 16px;
}

.el-input__icon {
  font-size: 20px;
}
</style>

<script>
// npm install v-di1stpicker --save
export default {
  data() {
    return {
      showEmail: "",
      password: "",
      rePassword: "",
      res: false,
      sendBtnText: this.$t('changeAccount.changeAccount14'),
      timeCount: 0,
      verifyCode: "",
      tip: "",
      tipActive: false,
      emailAddress: "",
      active: 0,
      disabled: false,
      timer: null,
      secretCode: "",
    };
  },
  methods: {
    checkPassword(type) {
      if (type == 0) {
          if (!this.password || !this.password.trim(" ")) {
            this.tip = this.$t('login.login11');
            this.tipActive = true;
          } else if (this.password.length < 6 || this.password.length > 16) {
            this.tip = this.$t('login.login12');
            this.tipActive = true;
          } else {
            var reg = /^(?![0-9]+$)(?![A-Z]+$)(?![a-z]+$)[0-9A-Za-z]{6,16}$/; //6-16位数字大小写字母组合
            if (reg.test(this.password)) {
            } else {
              this.tip = this.$t('login.login13');
              this.tipActive = true;
            }
          }
        } else if (type == 1) {
          if (!this.rePassword || !this.rePassword.trim(" ")) {
            this.tip = this.$t('login.login14');
            this.tipActive = true;
          } else {
            if (this.password != this.rePassword) {
              this.tip = this.$t('login.login15');
              this.tipActive = true;
            }
          }
        }
    },
    startTimer() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.timeCount = TIME_COUNT;
        this.disabled = true;
        this.timer = setInterval(() => {
          if (this.timeCount > 0 && this.timeCount <= TIME_COUNT) {
            this.timeCount--;
            this.sendBtnText = this.timeCount + this.$t('loginR.login33')+this.$t('loginR.login34');
          } else {
            this.disabled = false;
            this.sendBtnText = this.$t('loginR.login31');
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    checkVerityCode() {
      if (!this.verifyCode || !this.verifyCode.trim(" ")) {
          this.res = false;
          this.tip = this.$t('login.login16');
          this.tipActive = true;
        } else {
          const regMobile = /^[0-9]{4}$/;
          if (!regMobile.test(this.verifyCode)) {
            this.res = false;
            this.tip = this.$t('login.login17');
            this.tipActive = true;
          }
        }
    },
    async sendCode() {
      if (!this.disabled) {
        var url = "admin/sendVerificationCode";
        const { data: res } = await this.$http.get(url, {
          params: { email: this.emailAddress, smsType: 1 },
        });
        if (res.code == 200) {
          this.res = true;
          this.tip = this.$t('login.login18');
          this.tipActive = true;
          this.startTimer();
        } else {
          this.res = false;
          this.tip = res.message;
          this.tipActive = true;
        }
      }
    },
    clearTip() {
      (this.tip = ""), (this.tipActive = false);
    },
    checkInput() {
     if (!this.emailAddress || !this.emailAddress.trim(" ")) {
          this.tip = this.$t('login.login19');
          this.tipActive = true;
        } else {
          //  const regMobile = /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]+$/;
          const regMobile = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
           if (!regMobile.test(this.emailAddress)) {
             this.tip = this.$t('login.login20');
             this.tipActive = true;
           }
        }
    },
    async next() {
      if (this.active == 0) {
        this.clearTip();
        this.checkInput();
        if (!this.tipActive) {
          var url = "admin/verifyEmail";
          const { data: res } = await this.$http.get(url, {
            params: { email: this.emailAddress },
          });
          if (res.code == 200) {
            this.showEmail =this.emailAddress.substring(0, 3) +
                    "****" +
                    this.emailAddress.substring(this.emailAddress.indexOf("@"));
            this.tipActive = false;
            this.tip = "";
            this.active = 1;
            this.$refs.carousel.next();
          } else {
            this.res = false;
            this.tip = res.message;
            this.tipActive = true;
          }
        }
      } else if (this.active == 1) {
        this.checkVerityCode();
        if (!this.tipActive) {
          var url = "admin/verifyCode";
          const { data: res } = await this.$http.post(url, {
            email: this.emailAddress,
            code: this.verifyCode,
          });
          if (res.code == 200) {
            console.log(res);
            this.res = false;
            this.secretCode = res.data.secretCode;
            this.tipActive = false;
            this.tip = "";
            this.active = 2;
            this.$refs.carousel.next();
          } else {
            this.res = false;
            this.tip = res.message;
            this.tipActive = true;
          }
        }
      } else if (this.active == 2) {
        this.checkPassword(0);
        this.checkPassword(1);
        if (!this.tipActive) {
          var url = "admin/resetPassword";
          const { data: res } = await this.$http.post(url, {
            email: this.emailAddress,
            password: this.password,
            confirmPassword: this.rePassword,
            secretCode: this.secretCode,
          });
          if (res.code == 200) {
            clearInterval(this.timer);
            this.timer = null;
            this.tipActive = false;
            this.tip = "";
            this.active = 4;
            this.$refs.carousel.next();
            const TIME_COUNT = 3;
            if (!this.timer) {
              this.timeCount = TIME_COUNT;
              this.timer = setInterval(() => {
                if (this.timeCount > 0 && this.timeCount <= TIME_COUNT) {
                  this.timeCount--;
                } else {
                  clearInterval(this.timer);
                  this.timer = null;
                  this.$router.push({
                    name:'login'
                  });
                }
              }, 1000);
            }
          } else {
            this.tip = res.message;
            this.tipActive = true;
          }
        }
      } else if (this.active == 4) {
        this.$router.push({
          name:'login'
        });
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.clearTip();
      console.log(this.tip);
    });
  },
  watch: {
    tip() {
      console.log("changed");
      console.log(this.tip);
    },
  },
};
</script>
